import React, { useMemo,useState } from 'react'
import _, { set } from 'lodash'
import { useSelector } from 'react-redux'
import { locationsSelector } from '../../../store/slices/location'
import { Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, Stack, Typography,Checkbox, DialogActions, Button, Select, Menu, MenuItem } from '@mui/material'
import { convertArrayToDictionary, defaultGuid } from '../../../common/utils'
import CloseIcon from "@mui/icons-material/Close";
import moment from 'moment'
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ComparePrompt = ({open=false,handleClose,selectedPromptId,companyId}) => {
  const {prompts,users}=useSelector(locationsSelector)
  const usersDic=useMemo(()=>convertArrayToDictionary(_.clone(users),'userId'),[users])
  const [comparePrompt,setComparePrompt]=useState({})
  const [compareMode,setCompareMode]=useState(false)
  const [compareWith, setCompareWith]=useState("promptText")
  const [anchorEl, setAnchorEl] = useState(null);
  const selectedPrompt=useMemo(()=>{
    return _.find([...prompts],it=>it?.promptId===selectedPromptId)
  },[prompts,selectedPromptId])
  const promptsMemo=useMemo(()=>{
    const filteredPrompts = _.filter(prompts, it => (
      it.type === selectedPrompt?.type &&
      (it.subType || '') === (selectedPrompt?.subType || '') &&
      (it.companyId === defaultGuid || it.companyId === companyId)
  ));
    const finalData=_.filter([...filteredPrompts],it=>it?.promptId!==selectedPrompt?.promptId)
    return finalData
  },[selectedPrompt,prompts,companyId])
  const onClose=()=>{
    handleClose()
  }
  const onChecked=(e,row)=>{
    if(!e.target.checked){
     return setComparePrompt({})
    }
   return setComparePrompt(row)
  }
  const columns = useMemo(
    () => [
      {
        header: "",
        accessorKey: "",
        id: "checkbox",
        Cell: ({ row }) => {
          return (
            <Checkbox
              size="small"
              sx={{cursor:'pointer'}}
              checked={(comparePrompt?.promptId===row.original?.promptId)}
              onChange={(e) =>
                onChecked(e, row?.original)
              }
            />
          );
        },
      },
      {
        header: "Prompt Name",
        accessorKey: "name",
        Cell: ({ row }) => (
          <span>
            {row?.original?.name}
            {row?.original?.version && (
              <span style={{ color: '#8f9bb3' }}>
                {' '}
                (v{row?.original?.version})
              </span>
            )}
          </span>
        ),
      },
      
      {
        header: "Modified By",
        accessorKey: "modifiedBy",
         Cell: ({ row }) => usersDic[row?.original?.modifiedBy]?.firstName+ " "+usersDic[row?.original?.modifiedBy]?.lastName,
      },
      {
        header: "Modified On",
        accessorKey: "sysStartTime",
        Cell: ({ row }) =>
          moment
            .utc(row?.original?.sysStartTime)
            .local()
            .format("MM/DD/YYYY hh:mm A"),
      },
      {
        header: "LLM",
        accessorKey: "llm",
      },
      // {
      //   header: "Review Selection Type",
      //   accessorKey: "reviewSelectionType.value",
      //   id: "reviewSelectionType",
      // }
    ],
    [selectedPrompt, promptsMemo,comparePrompt]
  );
  const table = useMaterialReactTable({
    data:promptsMemo,
    columns,
    enableFullScreenToggle: false,
    enableStickyHeader: true,
    enablePagination: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableSorting: false,
    enableHiding: false,
    enableColumnActions: false,
    muiTableContainerProps: {
      sx: {
        maxHeight: "500px",
      },
    },
    muiTablePaperProps: {
      className: "std_table review-requests",
      sx: { boxShadow: "none" },
    },
    muiTableHeadProps: {
      sx: {
        position: "sticky",
        left: 0,
        top: 0,
      },
    },
    muiTableBodyCellProps: ({ row, column }) => {
      return {
        sx: {
          backgroundColor:"transparent",
          zIndex: 1,
          border: "none",
          padding: "4px 12px",
          "&:first-child": {
            minWidth: "50px !important",
            maxWidth: "50px !important",
          },
        },
      };
    },
    muiTableHeadCellProps: {
      sx: {
        padding: "4px 12px",
        "&:first-child": {
          minWidth: "50px !important",
          maxWidth: "50px !important",
        },
      },
    },
  });
  const handleCompare = (e, value)=>{
    setCompareMode(!compareMode)
    setCompareWith(value??"promptText");
    handleCloseMenu();
  }
  const handleCloseMenu = () => {
    setAnchorEl(null);
  }
  
  const prmptValue = useMemo(()=>{
    if(compareWith === "promptText"){
      return {newValue:comparePrompt?.promptText??'', oldValue:selectedPrompt?.promptText??''}
    }
    else if(compareWith === "systemPrompt"){
      return {newValue:comparePrompt?.systemPrompt??'', oldValue:selectedPrompt?.systemPrompt??''}
    }
    else if(compareWith === "responseJsonSchema"){
      return {newValue:comparePrompt?.responseJsonSchema??'', oldValue:selectedPrompt?.responseJsonSchema??''}
    }else{
      return {newValue:comparePrompt?.promptText??'', oldValue:selectedPrompt?.promptText??''}
    }
  }, [compareWith, selectedPrompt, comparePrompt]);
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth={"xl"} fullWidth>
    <DialogTitle>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography variant="h5">Compare</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
    </DialogTitle>
    <DialogContent dividers>
    {!compareMode&&<MaterialReactTable table={table}/>}
    {compareMode&&<div style={{maxHeight:'500px',overflow:'auto', minHeight:'300px'}}>
    <ReactDiffViewer
      styles={{ marker: { display: "none" },variables:{
        light:{diffViewerTitleBorderColor:'black'}
      } }}
      compareMethod={DiffMethod.CHARS}
      oldValue={prmptValue?.oldValue}
      newValue={prmptValue?.newValue}
      splitView={true}
      hideLineNumbers={true}
    />
    {!prmptValue?.oldValue&&!prmptValue?.newValue&&<Typography variant='body1' align='center' mt={2}>No content to compare</Typography>}
    </div>}
    </DialogContent>
    <DialogActions>
          <Stack
            direction="row"
            spacing={2}
            ml={2}
            py={1}
            sx={{ width: "100%" }}
          >
            {/* Button to open the comparison modal */}
           {<Button
              variant="contained"
              disabled={_.isEmpty(comparePrompt)}
              onClick={(e)=>{setCompareWith("promptText"); setCompareMode(!compareMode);}}
              sx={{padding:!compareMode?'6px 0px 6px 10px':'6px 10px', minWidth:'112px'}}
              
            >
              {compareMode?'Go back':'Compare'} 
              {!compareMode&&<IconButton
                size="small"
                onClick={(e) => { setAnchorEl(e.currentTarget); e.stopPropagation(); }}
                sx={{ py:0 }}
              >
                <KeyboardArrowDownIcon sx={{color:'#fff',}}/>
              </IconButton>}
            </Button>}
            {/* Button to cancel and close the dialog */}
            <Button variant="outlined" onClick={onClose}>
              Cancel
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              // onClick={handleCompare}
            >
              <MenuItem value="promptText" onClick={(e)=>handleCompare(e, "systemPrompt")}>System Prompt</MenuItem>
              <MenuItem value="promptText" onClick={(e)=>handleCompare(e, "promptText")}>User Prompt</MenuItem>
              <MenuItem value="responseJsonSchema" onClick={(e)=>handleCompare(e, "responseJsonSchema")}>Response Json Schema</MenuItem>
            </Menu>
          </Stack>
        </DialogActions>
    </Dialog>
  
  )
}

export default ComparePrompt